import { Flex, Button } from 'ui'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { usePendingInvitesContext } from '../context/PendingInvitesProvider'

export const Pagination = () => {
  const {
    state: { pageIndex, totalPages },
    actions: { nextPage: handleNextPage, previousPage: handlePreviousPage },
  } = usePendingInvitesContext()

  const enablePreviousPage = pageIndex > 0
  const enableNextPage = pageIndex < totalPages - 1

  return (
    <Flex alignItems="center" gap={3} mt={2} justifyContent="flex-end">
      <Flex alignItems="center" gap={2}>
        <Button
          variant="secondary"
          onClick={handlePreviousPage}
          style={{ padding: 5 }}
          title="Go to previous page"
          disabled={!enablePreviousPage}
        >
          <ChevronLeft size={18} />
        </Button>
        <Button
          variant="secondary"
          onClick={handleNextPage}
          style={{ padding: 5 }}
          title="Go to next page"
          disabled={!enableNextPage}
        >
          <ChevronRight size={18} />
        </Button>
      </Flex>
    </Flex>
  )
}
